import { isActiveEvidenceRunStatus } from "shared/sstv2MigrationEvidenceData"

/**
 * Chip colour for an evidence run's status. Its own file because both the tab's
 * detail header and the run-history table use it — a shared primitive living
 * inside one of its two consumers means deleting that consumer breaks the other
 * for a non-obvious reason (`.claude/rules/frontend-conventions.md`).
 */
export const evidenceStatusColor = (
  s: string,
): "success" | "info" | "error" | "default" =>
  s === "COMPLETED"
    ? "success"
    : s === "FAILED"
      ? "error"
      : isActiveEvidenceRunStatus(s)
        ? "info"
        : "default"
